/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Edge_LabelInputs */

const cs_workflow_edge_label = /** @type {(inputs: Workflow_Edge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označení spojení`)
};

const en_workflow_edge_label = /** @type {(inputs: Workflow_Edge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edge label`)
};

/**
* | output |
* | --- |
* | "Edge label" |
*
* @param {Workflow_Edge_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_edge_label = /** @type {((inputs?: Workflow_Edge_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Edge_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_edge_label(inputs)
	return cs_workflow_edge_label(inputs)
});